import { Flex, LightMode } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { MenuItem } from "../SearchMenu/MenuItem";

export function MenuSearch() {
  const { menu } = useConfigurationMenu({ alias: "search" });

  if (!menu || menu.items.length <= 0) {
    return null;
  }

  return (
    <Flex mt="1rem" gridGap="0.875rem" wrap="wrap" w="inherit">
      <LightMode>
        {menu.items.map((menuItem) => (
          <MenuItem
            key={menuItem.id}
            menuItem={menuItem}
            flex="1"
            minW={{
              base: "full",
              md: "calc(50% - 0.875rem)",
              lg: "auto",
            }}
          />
        ))}
      </LightMode>
    </Flex>
  );
}
